import React, { useRef, useEffect, useMemo, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Col, Row, Steps, Form } from 'antd'
import { SelectValue } from 'antd/lib/select'
import {
  Input,
  Select,
  SelectCity,
  SelectCountry,
  SelectState,
  Switch as SwitchFormik
} from 'src/components/Formik'
import { Marker } from 'react-google-maps'
import { Formik, FormikProps } from 'formik'

import { Place, User } from 'src/types'
import { sendPartner } from 'src/core/store/ducks/partners/actions'
import { sendPartnerHotel } from 'src/core/store/ducks/partners/hotels/actions'
import { Text, Button } from 'src/components/Ant'
import { useT } from 'src/core/hooks/use-translation'
import MapContainer from 'src/components/MapContainer'

import * as CSS from './styles'
import * as InitialValues from './initial-values'
import * as validationSchema from './validation-schema'

interface SideModalProps {
  isNew: boolean
  partner: User
  responsePartner: any
  setOpenSideModal: (openSideModal: boolean) => void
}

const optionsHotelCategoryStars = [
  {
    label: '1',
    value: '1'
  },
  {
    label: '2',
    value: '2'
  },
  {
    label: '3',
    value: '3'
  },
  {
    label: '4',
    value: '4'
  },
  {
    label: '5',
    value: '5'
  }
]

export function SideModal({
  isNew,
  responsePartner,
  partner,
  setOpenSideModal
}: SideModalProps) {
  const { t } = useT()
  const { Step } = Steps

  const refMap = useRef(null)
  const refFormikPartner = useRef(null)
  const refFormikHotel = useRef(null)

  const dispatch = useDispatch()

  const [formikHotel, setFormikHotel] = useState<any>(
    InitialValues.getInitialValuesHotel(partner)
  )
  const [formikPartner, setFormikPartner] =
    useState<InitialValues.InitialValuesPartnerProps>()
  const [current, setCurrent] = useState(0)

  function next() {
    setCurrent(current + 1)
  }

  function sendPartnerData({ valuesPartner }: any) {
    dispatch(sendPartner(valuesPartner))
  }

  useEffect(() => {
    if (responsePartner?.response?.partner?.partner_id) {
      sendHotelData(formikHotel)
      setOpenSideModal(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responsePartner, formikHotel])

  const sendHotelData = useCallback(
    formikValues => {
      dispatch(
        sendPartnerHotel({
          ...formikValues,
          brand_name: formikPartner.partner_name,
          partner_hotel_number: 2,
          partner_id: responsePartner.response.partner.partner_id
        })
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formikHotel, formikPartner, responsePartner]
  )

  const googleGeocoderService = useMemo(
    // @ts-ignore
    () => new window.google.maps.Geocoder(),
    []
  )

  const boundMap = useCallback(
    (lat, lng) => {
      const map =
        refMap.current && refMap.current.state && refMap.current.state.map

      if (map) {
        // @ts-ignore
        const bounds = new window.google.maps.LatLngBounds()
        bounds.extend(
          // @ts-ignore
          new window.google.maps.LatLng(lat, lng)
        )
        map.fitBounds(bounds, 50)
      }
    },
    [refMap]
  )

  const optionsHotelClass = [
    {
      label: t('web.table.hotel.options_hotel_class.agreement'),
      value: 'AGREEMENT'
    },
    {
      label: t('web.table.hotel.options_hotel_class.preferable'),
      value: 'PREFERABLE'
    }
  ]

  function Step1PartnerFormik() {
    return (
      <Formik
        initialValues={InitialValues.getInitialValuesPartner(partner)}
        onSubmit={() => {}}
        ref={refFormikPartner}
        render={(formikProps: FormikProps<any>) => (
          <Form
            onSubmit={formikProps.handleSubmit}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                formikProps.handleSubmit()
              }
            }}
          >
            <Row gutter={[12, 0]}>
              <Col span={16}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.partner_name.name"
                  name="partner_name"
                  placeholder="web.table.head-partner.partner_name.placeholder"
                />
              </Col>

              <Col span={8}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.partner_vat_number.name"
                  name="partner_vat_number"
                  placeholder="web.table.head-partner.partner_vat_number.placeholder"
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.description.name"
                  name="partner_description"
                  placeholder="web.table.head-partner.description.placeholder"
                />
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={8}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.zip_code.name"
                  name="zip_code"
                  placeholder="web.table.head-partner.zip_code.placeholder"
                />
              </Col>
              <Col span={16}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.address.name"
                  name="address"
                  placeholder="web.table.head-partner.address.placeholder"
                />
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={8}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.address_number.name"
                  name="address_number"
                  placeholder="web.table.head-partner.address_number.placeholder"
                />
              </Col>
              <Col span={16}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.quarter.name"
                  name="quarter"
                  placeholder="web.table.head-partner.quarter.placeholder"
                />
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={8}>
                <SelectCountry
                  formikProps={formikProps}
                  label="web.table.head-partner.country.name"
                  name="country_id"
                  style={{ width: '100%' }}
                  onChange={() => {
                    formikProps.setFieldValue('state', null)
                    formikProps.setFieldValue('state_id', null)
                    formikProps.setFieldValue('city', null)
                    formikProps.setFieldValue('city_id', null)
                  }}
                  required
                />
              </Col>
              <Col span={8}>
                <SelectState
                  country={formikProps.values && formikProps.values.country_id}
                  style={{ width: '100%' }}
                  formikProps={formikProps}
                  label="web.table.head-partner.estate.name"
                  name="state_id"
                  onChange={() => {
                    formikProps.setFieldValue('city', null)
                    formikProps.setFieldValue('city_id', null)
                  }}
                  required
                />
              </Col>
              <Col span={8}>
                <SelectCity
                  state={formikProps.values && formikProps.values.state_id}
                  style={{ width: '100%' }}
                  formikProps={formikProps}
                  label="web.table.head-partner.city_id.name"
                  name="city_id"
                  placeholder="web.table.head-partner.city_id.placeholder"
                  onChange={(
                    value: SelectValue,
                    option: React.ReactElement<any> | React.ReactElement<any>[]
                  ) => {
                    const place: Place = {
                      // @ts-ignore
                      label: option.props.title,
                      // @ts-ignore
                      value: option.props.value
                    }
                    const address = formikProps.values
                    googleGeocoderService.geocode(
                      {
                        address:
                          address.address +
                          ',' +
                          address.address_number +
                          ',' +
                          place.label
                        // placeId: place.value
                      },
                      (results: any) => {
                        formikProps.setFieldValue(
                          'latitude',
                          results[0].geometry.location.lat()
                        )
                        formikProps.setFieldValue(
                          'longitude',
                          results[0].geometry.location.lng()
                        )
                        boundMap(
                          results[0].geometry.location.lat(),
                          results[0].geometry.location.lng()
                        )
                      }
                    )
                  }}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <CSS.Card bodyStyle={{ height: 400 }}>
                  <MapContainer ref={refMap}>
                    {formikProps.values.latitude &&
                      formikProps.values.longitude && (
                        <Marker
                          position={{
                            lat: formikProps.values.latitude,
                            lng: formikProps.values.longitude
                          }}
                        />
                      )}
                  </MapContainer>
                </CSS.Card>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  formikProps={formikProps}
                  label="web.table.head-partner.additional_info.name"
                  name="additional_info"
                  placeholder="web.table.head-partner.additional_info.placeholder"
                />
              </Col>
            </Row>
            <CSS.Div>
              <div>
                <Button
                  onClick={async () => {
                    setOpenSideModal(false)
                    setCurrent(0)
                  }}
                  type="default"
                  title="common.actions.cancel"
                />
                <CSS.Button
                  type="primary"
                  onClick={async () => {
                    await formikProps.submitForm()
                    const validateReturn = await formikProps.validateForm()
                    if (
                      current === 0 &&
                      Object.keys(validateReturn).length === 0
                    ) {
                      setFormikPartner(formikProps.values)
                      next()
                    }
                  }}
                  title={
                    current === 0
                      ? 'common.actions.next'
                      : isNew
                      ? 'common.actions.save'
                      : 'common.actions.change'
                  }
                />
              </div>
            </CSS.Div>
          </Form>
        )}
        validationSchema={validationSchema.Partner}
      />
    )
  }

  function Step2HotelFormik() {
    return (
      <Formik
        ref={refFormikHotel}
        initialValues={InitialValues.getInitialValuesHotel(partner)}
        validationSchema={validationSchema.Hotel}
        onSubmit={() => {}}
        render={(formikProps: FormikProps<any>) => (
          <Form style={{ position: 'relative' }}>
            <Row gutter={[12, 0]}>
              <Col span={16}>
                <Select
                  dataTestId="hotel-class"
                  filterOption={false}
                  formikProps={formikProps}
                  label="web.table.hotel.hotel_class.name"
                  style={{ width: '100%' }}
                  // loading={loading}
                  name="hotel_class"
                  onChange={(value: SelectValue) => {
                    formikProps.setFieldValue('hotel_class', value)
                  }}
                  options={optionsHotelClass}
                  placeholder="web.table.hotel.hotel_class.placeholder"
                  showSearch
                />
              </Col>

              <Col span={8}>
                <Input
                  formikProps={formikProps}
                  label="web.table.hotel.hotel_image_url.name"
                  name="hotel_image_url"
                  placeholder="web.table.hotel.hotel_image_url.placeholder"
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  formikProps={formikProps}
                  label="web.table.hotel.information.name"
                  name="information"
                  placeholder="web.table.hotel.information.placeholder"
                />
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={16}>
                <Select
                  dataTestId="hotel-category-stars"
                  filterOption={false}
                  formikProps={formikProps}
                  label="web.table.hotel.category_stars.name"
                  style={{ width: '100%' }}
                  // loading={loading}
                  name="category_stars"
                  onChange={(
                    value: SelectValue,
                    option: React.ReactElement<any> | React.ReactElement<any>[]
                  ) => {
                    formikProps.setFieldValue('category_stars', value)
                  }}
                  // onSearch={onSearch}
                  options={optionsHotelCategoryStars}
                  placeholder="web.table.hotel.category_stars.placeholder"
                  showSearch
                />
              </Col>
              <Col span={8}>
                <Input
                  formikProps={formikProps}
                  label="web.table.hotel.nights.name"
                  name="nights"
                  placeholder="web.table.hotel.nights.placeholder"
                />
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={12}>
                <CSS.HotelRow>
                  <label style={{ paddingTop: '10px' }}>
                    {t('web.table.hotel.pool')}
                  </label>
                  <div style={{ paddingRight: '20px' }}>
                    <SwitchFormik
                      checkedChildren={
                        <Text title="common.actions.yes" onlyText />
                      }
                      formikProps={formikProps}
                      name="pool"
                      unCheckedChildren={
                        <Text title="common.actions.no" onlyText />
                      }
                    />
                  </div>
                </CSS.HotelRow>
              </Col>
              <Col span={12}>
                <CSS.HotelRow>
                  <label style={{ paddingTop: '10px' }}>
                    {t('web.table.hotel.parking')}
                  </label>

                  <SwitchFormik
                    checkedChildren={
                      <Text title="common.actions.yes" onlyText />
                    }
                    formikProps={formikProps}
                    name="parking"
                    unCheckedChildren={
                      <Text title="common.actions.no" onlyText />
                    }
                  />
                </CSS.HotelRow>
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={12}>
                <CSS.HotelRow>
                  <label style={{ paddingTop: '10px' }}>
                    {t('web.table.hotel.restaurant')}
                  </label>
                  <div style={{ paddingRight: '20px' }}>
                    <SwitchFormik
                      checkedChildren={
                        <Text title="common.actions.yes" onlyText />
                      }
                      formikProps={formikProps}
                      name="restaurant"
                      unCheckedChildren={
                        <Text title="common.actions.no" onlyText />
                      }
                    />
                  </div>
                </CSS.HotelRow>
              </Col>
              <Col span={12}>
                <CSS.HotelRow>
                  <label style={{ paddingTop: '10px' }}>
                    {t('web.table.hotel.laundry')}
                  </label>

                  <SwitchFormik
                    checkedChildren={
                      <Text title="common.actions.yes" onlyText />
                    }
                    formikProps={formikProps}
                    name="laundry"
                    unCheckedChildren={
                      <Text title="common.actions.no" onlyText />
                    }
                  />
                </CSS.HotelRow>
              </Col>
            </Row>
            <Row gutter={[12, 0]}>
              <Col span={12}>
                <CSS.HotelRow>
                  <label style={{ paddingTop: '10px' }}>
                    {t('web.table.hotel.refundable')}
                  </label>
                  <div style={{ paddingRight: '20px' }}>
                    <SwitchFormik
                      checkedChildren={
                        <Text title="common.actions.yes" onlyText />
                      }
                      formikProps={formikProps}
                      name="refundable"
                      unCheckedChildren={
                        <Text title="common.actions.no" onlyText />
                      }
                    />
                  </div>
                </CSS.HotelRow>
              </Col>
            </Row>
            <CSS.Container>
              <CSS.Div>
                <div>
                  <Button
                    onClick={async () => {
                      setOpenSideModal(false)
                      setCurrent(0)
                    }}
                    type="default"
                    title="common.actions.cancel"
                  />
                  <CSS.Button
                    type="primary"
                    onClick={async () => {
                      await formikProps.submitForm()
                      const validateReturn = await formikProps.validateForm()
                      if (Object.keys(validateReturn).length === 0) {
                        setFormikHotel(() => formikProps.values)
                        sendPartnerData({
                          valuesPartner: formikPartner
                        })
                      }
                    }}
                    title={
                      current === 0
                        ? 'common.actions.next'
                        : isNew
                        ? 'common.actions.save'
                        : 'common.actions.change'
                    }
                  />
                </div>
              </CSS.Div>
            </CSS.Container>
          </Form>
        )}
      />
    )
  }

  const steps = [
    {
      title: t('web.table.head-partner.partner'),
      content: <Step1PartnerFormik />
    },
    {
      title: t('web.table.hotel.hotel'),
      content: <Step2HotelFormik />
    }
  ]

  return (
    <>
      <Steps current={current}>
        {steps.map(item => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div className="steps-content">{steps[current].content}</div>
    </>
  )
}
